<p-toast key="editMessage"></p-toast>
<div class="md:mt-2">
    <div class="container" *ngIf="this.invoiceData.data.studentList.length > 0">
        <div class="row p-0">
            <div
                class="flex mt-1 block"
                *ngFor="let studentDetails of this.invoiceData.data.studentList"
            >
                <img
                    *ngIf="
                        studentDetails.profileimg != undefined;
                        else noImageFound
                    "
                    [src]="studentDetails.profileimg"
                    width="43"
                    height="43"
                    alt="profile"
                    class="border-circle border-2 border-primary flex-shrink-0 shadow-4"
                />
                <ng-template #noImageFound>
                    <!-- start of logic -->
                    <div
                        [ngStyle]="{
                            background: getProfileBgColor(studentDetails.id),
                            'width.px': 43,
                            'height.px': 43,
                            display: 'flex',
                            'align-items': 'center',
                            'justify-content': 'center',
                            'border-radius': '50%'
                        }"
                        class="flex-shrink-0 shadow-4 text-white font-bold"
                    >
                        {{ getInitials(studentDetails.fullName) }}
                    </div>
                    <!-- end of logic -->
                </ng-template>
                <div class="ml-2 mt-3">
                    <div class="text-base font-bold text-900 mb-0">
                        <a class="student-name">{{
                            studentDetails.fullName
                        }}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="col-12">
        <form [formGroup]="invoiceForm">
            <div class="row">
                <div class="col-4">
                    <div class="field col-md-12 col-sm-12 pr-md-2">
                        <label
                            htmlFor="dueDate"
                            style="opacity: 50%"
                            [appAsterisk]="true"
                            >Invoice Due Date</label
                        >
                        <input
                            type="date"
                            pInputText
                            placeholder="Invoice Due Date"
                            class="w-full custom-input-filter"
                            formControlName="dueDate"
                        />
                    </div>
                </div>
                <div class="col-8">
                    <div class="field col-md-12 col-sm-12 pr-md-2">
                        <label
                            for="startDate"
                            [appAsterisk]="optionalDateControl"
                            style="opacity: 50%"
                            >Date of Service (Optional)</label
                        >
                        <div class="d-flex">
                            <input
                                type="date"
                                pInputText
                                placeholder="Invoice Due Date"
                                class="w-full custom-input-filter"
                                formControlName="startDate"
                            />
                            <span class="mx-4" style="opacity: 50%">to</span>
                            <input
                                type="date"
                                pInputText
                                placeholder="Invoice Due Date"
                                class="w-full custom-input-filter"
                                formControlName="endDate"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <li
                class="flex justify-content-between border-top-2 surface-border py-3"
            ></li>
            <form [formGroup]="invoiceItemForm">
                <div formArrayName="dynamicArray">
                    <div
                        class="surface-card grid grid-nogutter border-round shadow-2 mb-4"
                    >
                        <!-- Header Row -->
                        <!-- <div
                            class="col-12 flex p-2 surface-100 border-round-top"
                            style="max-height: 48px">
                            <div class="p-2 col-2 text-center md:text-left">
                                <span class="text-700 block">Type</span>
                            </div>
                            <p-divider
                                align="center"
                                layout="vertical"
                                styleClass="h-full mx-0 lg:mx-3 surface-border"></p-divider>
                            <div class="p-2 col-6 text-center md:text-left">
                                <span class="text-700 block" [appAsterisk]="true">Item Description</span>
                            </div>
                            <p-divider
                                align="center"
                                layout="vertical"
                                styleClass="h-full mx-0 lg:mx-3 surface-border"></p-divider>
                            <div class="p-2 col-1 text-center md:text-left">
                                <span class="text-700 block" [appAsterisk]="true">Amount</span>
                            </div>
                            <p-divider
                                align="center"
                                layout="vertical"
                                styleClass="h-full mx-0 lg:mx-3 surface-border"></p-divider>
                            <div class="p-2 col text-center md:text-center">
                                <span class="text-700 block ml-3">Action</span>
                            </div>
                        </div> -->

                        <!-- Dynamic Rows -->
                        <div
                            class="col-12 add-invoice"
                            *ngFor="
                                let invoiceItem of dynamicArray.controls;
                                let i = index
                            "
                            [formGroupName]="i"
                        >
                            <div
                                class="p-2 my-2 flex flex-row justify-content-between align-items-center"
                            >
                                <!-- Type Dropdown -->
                                <div
                                    class="col-2 text-center md:text-left px-2"
                                >
                                    <label for="type" style="opacity: 50%"
                                        >Type</label
                                    >
                                    <p-dropdown
                                        [options]="getInvoiceTypeOptions(i)"
                                        formControlName="type"
                                        optionLabel="name"
                                        class="custom-dropdown-filter w-full"
                                        optionValue="id"
                                        (onChange)="onTypeChange($event, i)"
                                        placeholder="Select Type"
                                    >
                                    </p-dropdown>
                                </div>

                                <!-- Item Description Input -->
                                <div class="col-6 text-center md:text-left p-1">
                                    <label
                                        for="description"
                                        style="opacity: 50%"
                                        >Item Description</label
                                    >
                                    <ng-container
                                        [ngSwitch]="
                                            dynamicArray.controls[i].get('type')
                                                ?.value
                                        "
                                    >
                                        <input
                                            pInputText
                                            *ngSwitchCase="'newItem'"
                                            type="text"
                                            class="placeholder-style w-full"
                                            placeholder="Add Invoice Description"
                                            appFirstLetterCapital
                                            formControlName="description"
                                        />

                                        <div *ngSwitchCase="'presetItem'">
                                            <p-dropdown
                                                class="dropPreset"
                                                [options]="presetItemList"
                                                formControlName="description"
                                                appendTo="body"
                                                placeholder="Add Description"
                                                [showClear]="true"
                                                optionLabel="name"
                                                optionValue="name"
                                                (onChange)="
                                                    changePresetItem(i, $event)
                                                "
                                                (onClear)="
                                                    changePresetItem(i, $event)
                                                "
                                            >
                                                <ng-template
                                                    pTemplate="item"
                                                    let-option
                                                >
                                                    <div>{{ option.name }}</div>
                                                </ng-template>
                                                <ng-template pTemplate="footer">
                                                    <div
                                                        class="surface-card grid grid-nogutter border-round shadow-2 mb-4"
                                                    >
                                                        <div
                                                            class="col-12 flex p-2 surface-100 border-round-top"
                                                            style="
                                                                max-height: 38px;
                                                            "
                                                        >
                                                            <div
                                                                class="text-center md:text-left"
                                                            >
                                                                <span
                                                                    class="text-cyan-300 text-700 block font-semibold hover-pointer"
                                                                    (click)="
                                                                        onItemSetting(
                                                                            'Manage Presets'
                                                                        )
                                                                    "
                                                                    ><i
                                                                        class="pi pi-cog"
                                                                    ></i
                                                                    >&nbsp;&nbsp;
                                                                    Manage
                                                                    Presets</span
                                                                >
                                                            </div>
                                                        </div>
                                                    </div>
                                                </ng-template>
                                            </p-dropdown>
                                        </div>

                                        <div
                                            *ngSwitchCase="'discount'"
                                            class="align-items-center row"
                                        >
                                            <div class="col-2 p-1">
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    [placeholder]="
                                                        dynamicArray.controls[
                                                            i
                                                        ].get('currencySign')
                                                            ?.value === '%'
                                                            ? '0'
                                                            : '$0'
                                                    "
                                                    pKeyFilter="money"
                                                    (input)="
                                                        onDeductionAmtChange(
                                                            i,
                                                            $event
                                                        )
                                                    "
                                                    formControlName="deductionAmt"
                                                />
                                            </div>
                                            <div class="col-2 p-1">
                                                <select
                                                    class="form-control"
                                                    formControlName="currencySign"
                                                    (change)="
                                                        onCurrencyChange(
                                                            i,
                                                            'discount',
                                                            $event
                                                        )
                                                    "
                                                >
                                                    <option value="%">%</option>
                                                    <option value="$">$</option>
                                                </select>
                                            </div>
                                            <div
                                                class="col-3 p-1"
                                                *ngIf="
                                                    dynamicArray.controls[
                                                        i
                                                    ].get('currencySign')
                                                        ?.value === '%'
                                                "
                                            >
                                                <div class="row">
                                                    <div class="col-sm-2">
                                                        <p class="of-label">
                                                            Of
                                                        </p>
                                                    </div>
                                                    <div class="col-sm-8">
                                                        <input
                                                            type="text"
                                                            class="form-control"
                                                            placeholder="$0"
                                                            pKeyFilter="money"
                                                            formControlName="percentageAmt"
                                                            [required]="dynamicArray.controls[i].get('currencySign')?.value === '%'"
                                                            [ngClass]="{
                                                                'border-red':
                                                                  dynamicArray.controls[i].get('currencySign')?.value === '%' &&
                                                                  !dynamicArray.controls[i].get('percentageAmt')?.value
                                                              }"
                                                            (input)="
                                                                onPercentageAmtChange(
                                                                    i,
                                                                    $event
                                                                )
                                                            "
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div
                                                [ngClass]="
                                                    dynamicArray.controls[
                                                        i
                                                    ].get('currencySign')
                                                        ?.value === '%'
                                                        ? 'col-5 p-1'
                                                        : 'col p-1'
                                                "
                                            >
                                                <p-dropdown
                                                    class="dropPreset"
                                                    [options]="discountItemList"
                                                    placeholder="Add Description"
                                                    formControlName="description"
                                                    appendTo="body"
                                                    [showClear]="true"
                                                    optionValue="name"
                                                    optionLabel="name"
                                                >
                                                    <ng-template
                                                        pTemplate="item"
                                                        let-option
                                                    >
                                                        <div>
                                                            {{ option.name }}
                                                        </div>
                                                    </ng-template>
                                                    <ng-template
                                                        pTemplate="footer"
                                                    >
                                                        <div
                                                            class="surface-card grid grid-nogutter border-round shadow-2 mb-4"
                                                        >
                                                            <div
                                                                class="col-12 flex p-2 surface-100 border-round-top"
                                                                style="
                                                                    max-height: 38px;
                                                                "
                                                            >
                                                                <div
                                                                    class="text-center md:text-left"
                                                                >
                                                                    <span
                                                                        class="text-cyan-300 text-700 block font-semibold hover-pointer"
                                                                        (click)="
                                                                            onItemSetting(
                                                                                'Manage Discount'
                                                                            )
                                                                        "
                                                                        ><i
                                                                            class="pi pi-cog"
                                                                        ></i
                                                                        >&nbsp;Manage
                                                                        Discount</span
                                                                    >
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </ng-template>
                                                </p-dropdown>
                                            </div>
                                        </div>

                                        <div
                                            *ngSwitchCase="'subsidy'"
                                            class="align-items-center row"
                                        >
                                            <div class="col-2 p-1">
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    [placeholder]="
                                                        dynamicArray.controls[
                                                            i
                                                        ].get('currencySign')
                                                            ?.value === '%'
                                                            ? '0'
                                                            : '$0'
                                                    "
                                                    pKeyFilter="money"
                                                    (input)="
                                                        onDeductionAmtChange(
                                                            i,
                                                            $event
                                                        )
                                                    "
                                                    formControlName="deductionAmt"
                                                />
                                            </div>
                                            <div class="col-2 p-1">
                                                <select
                                                    class="form-control"
                                                    formControlName="currencySign"
                                                    (change)="
                                                        onCurrencyChange(
                                                            i,
                                                            'discount',
                                                            $event
                                                        )
                                                    "
                                                >
                                                    <option value="%">%</option>
                                                    <option value="$">$</option>
                                                </select>
                                            </div>
                                            <div
                                                class="col-3 p-1"
                                                *ngIf="
                                                    dynamicArray.controls[
                                                        i
                                                    ].get('currencySign')
                                                        ?.value === '%'
                                                "
                                            >
                                                <div class="row">
                                                    <div class="col-sm-1">
                                                        <p class="of-label" >
                                                            Of

                                                        </p>
                                                    </div>
                                                    <div class="col-sm-8">
                                                        <input
                                                            type="text"
                                                            class="form-control"
                                                            placeholder="$0"
                                                            pKeyFilter="money"
                                                            formControlName="percentageAmt"
                                                            [required]="dynamicArray.controls[i].get('currencySign')?.value === '%'"
                                                            [ngClass]="{
                                                                'border-red':
                                                                  dynamicArray.controls[i].get('currencySign')?.value === '%' &&
                                                                  !dynamicArray.controls[i].get('percentageAmt')?.value
                                                              }"
                                                            (input)="
                                                                onPercentageAmtChange(
                                                                    i,
                                                                    $event
                                                                )
                                                            "
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div
                                                [ngClass]="
                                                    dynamicArray.controls[
                                                        i
                                                    ].get('currencySign')
                                                        ?.value === '%'
                                                        ? 'col-5 p-1'
                                                        : 'col p-1'
                                                "
                                            >
                                                <p-dropdown
                                                    class="dropPreset"
                                                    [options]="subsidyItemList"
                                                    placeholder="Add Description"
                                                    formControlName="description"
                                                    appendTo="body"
                                                    optionLabel="name"
                                                    optionValue="name"
                                                >
                                                    <ng-template
                                                        pTemplate="item"
                                                        let-option
                                                    >
                                                        <div>
                                                            {{ option.name }}
                                                        </div>
                                                    </ng-template>
                                                </p-dropdown>
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>

                                <!-- Amount Input -->
                                <div
                                    class="col-2 text-center md:text-left pr-2 flex flex-column"
                                >
                                    <label for="amount" style="opacity: 50%"
                                        >Amount</label
                                    >
                                    <ng-container
                                        [ngSwitch]="
                                            dynamicArray.controls[i].get('type')
                                                ?.value
                                        "
                                    >
                                        <input
                                            *ngSwitchCase="'newItem'"
                                            placeholder="$0"
                                            class="form-control amt-input"
                                            pKeyFilter="money"
                                            formControlName="amount"
                                            style="width: 100%; height: 40px"
                                        />
                                        <input
                                            *ngSwitchCase="'presetItem'"
                                            placeholder="$0"
                                            class="form-control amt-input"
                                            pKeyFilter="money"
                                            formControlName="amount"
                                            style="width: 100%; height: 40px"
                                        />
                                        <span
                                            *ngSwitchCase="'discount'"
                                            class="font-medium text-red-600"
                                            >${{ shouldShowNegativeSign(i, 'discount') ? "-" : "" }}{{ getDiscountDisplayValue(i, 'discount') }}</span
                                        >
                                        <span
                                            *ngSwitchCase="'subsidy'"
                                            class="font-medium text-red-600"
                                            >${{ shouldShowNegativeSign(i, 'subsidy') ? "-" : "" }}{{ getDiscountDisplayValue(i, 'subsidy') }}</span
                                        >
                                    </ng-container>
                                </div>

                                <div
                                    class="col-1 text-center md:text-left pr-2"
                                >
                                    <p-button
                                        icon="pi pi-trash"
                                        styleClass="p-button-rounded p-button-danger p-button-text"
                                        [disabled]="i === 0"
                                        (onClick)="
                                            deleteItem($event, invoiceItem, i)
                                        "
                                    >
                                    </p-button>
                                </div>
                                <p-confirmPopup key="confirm1"></p-confirmPopup>
                            </div>

                            <li
                                class="flex justify-content-between border-top-1 surface-border py-1"
                            ></li>
                        </div>

                        <div class="col-12 flex add-invoice">
                            <label for=""></label>
                            <div
                                class="col-12 flex add-invoice-button border-round"
                            >
                                <div class="col-4 p-0">
                                    <span
                                        class="text-xl font-semibold"
                                        style="cursor: pointer"
                                        [ngClass]="{
                                            disabled: !invoiceItemForm.valid
                                        }"
                                        (click)="addMoreFormGroup()"
                                    >
                                        Add Invoice Item
                                    </span>
                                    <br />
                                    <p class="text-sm">
                                        Preset Charges, Discounts & Subsidy
                                    </p>
                                </div>
                                <div class="col-5 p-0"></div>

                                <div class="col-3 text-2xl font-semibold p-0">
                                    <span
                                        >Total : $ {{ getTotalAmount() | number:'1.2-2' }}</span
                                    >
                                     <!-- Amount validation message -->
                                    <div 
                                        *ngIf="invoiceForm.errors?.['invalidAmount']" 
                                        class="text-red-500 text-sm mt-2"
                                    >
                                        {{ getAmountValidationMessage() }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <span class="p-float-label mt-6">
                <textarea
                    formControlName="note"
                    id="note"
                    [rows]="2"
                    class="full-width-textarea placeholder-style w-full"
                    pInputTextarea
                    appFirstLetterCapital
                ></textarea>
                <label for="float-input">Add optional internal note</label>
            </span>
        </form>
    </div>
    <div class="row">
        <div class="col">
            <div class="d-flex justify-content-center gap-2">
                <button
                    pButton
                    pRipple
                    type="button"
                    label="Cancel"
                    class="p-button-outlined"
                    (click)="ref.close()"
                ></button>

                <p-button
                    label="Save"
                    (click)="onSubmit('save')"
                    [disabled]="!invoiceForm.valid || !invoiceItemForm.valid"
                    [loading]="!submitButton && buttonType == 'save'"
                    class="p-button-secondary"
                ></p-button>

                <p-button
                    label="Save and Send"
                    [disabled]="!invoiceForm.valid || !invoiceItemForm.valid"
                    (click)="onSubmit('send')"
                    [loading]="!submitButton && buttonType == 'send'"
                    class="p-button-secondary"
                ></p-button>
            </div>
        </div>
    </div>
</div>
